import DashboardComp from 'components/Dashboard/DashboardComp'
import { useUser } from 'contexts/UserContext'
import useFetch from 'hooks/useFetch'
import { useEffect } from 'react'

export default function DashboardPage() {
  const { user } = useUser()

  // useFetch(): hook personalizado para realizar solicitudes GET, POST, PUT, DELETE
  const [fetchedIncidents, fetchIncdents] = useFetch()
  const [fetchedLogs, fetchLogs] = useFetch()

  // CRUD: GET
  const handleGet = async () => {
    try {
      const incidentsApiCall = {
        url: 'incidents/all',
        method: 'GET',
        messageKo: '¡Error al recoger siniestros!'
      }

      const logsApiCall = {
        url: `logs/import`,
        method: 'GET',
        messageKo: '¡Error al recoger registro!'
      }

      const apiCalls = [fetchIncdents(incidentsApiCall)]
      if (logsApiCall) apiCalls.push(fetchLogs(logsApiCall))

      await Promise.all(apiCalls)
    } catch (error) {
      console.error('Dashboard - Error:', error)
    }
  }

  // Ejecutar GET
  useEffect(() => {
    handleGet()
  }, [])

  return (
    <DashboardComp
      fetchedIncidents={fetchedIncidents}
      fetchedLogs={fetchedLogs}
    />
  )
}
